export default "__VITE_ASSET__C3F_rMy9__"